import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TermwebConfiguration} from '@twpub/core/models';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'pub-termweb-connection-settings-display',
  templateUrl: './termweb-connection-settings-display.component.html',
  styleUrls: ['./termweb-connection-settings-display.component.scss'],
  standalone: true,
  imports: [MatButton]
})
export class TermwebConnectionSettingsDisplayComponent {
  @Input() configuration!: TermwebConfiguration;
  @Input() editable = true;

  @Output() editConfiguration: EventEmitter<TermwebConfiguration> = new EventEmitter<TermwebConfiguration>();

  edit() {
    this.editConfiguration.emit(this.configuration);
  }
}
